import React from 'react';
import { connect } from 'react-redux';
import { Form as  FormFinal, Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { Button, Table, Alert, Card, Form, Col, Spinner } from 'react-bootstrap';
import ReactDragListView from 'react-drag-listview';

import { CommentEdit } from '@styled-icons/boxicons-regular/CommentEdit';
import { QuestionAnswer } from '@styled-icons/material-twotone/QuestionAnswer';
import { ChevronsUp } from '@styled-icons/boxicons-regular/ChevronsUp';
import { ChevronsDown } from '@styled-icons/boxicons-regular/ChevronsDown';
import { Drag } from '@styled-icons/fluentui-system-filled/Drag';

//Actions
import { pesquisa, novoatualiza, atualizaPesquisa } from '../../../../actions/questionario/questionarios';
import { pesquisaCategorias } from '../../../../actions/forms/validacao';

//Components
import { campotexto, camporadio, camposelect } from '../../../../components/forms/campos/campos';
import FormPergRespCadastroRespostas from './FormPergRespCadastroRespostas';

//Utils
import { getEvento } from '../../../../utils/eventosession';

//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';

class FormPergRespCadastro extends React.Component {

    state = {
        perguntaedicao: false,
        perguntarespostasedicao: false,
        showrespostas: false,
        passo: 1
    }
    
    async componentDidMount(){
        const evento = getEvento();
        await this.props.pesquisa({
            idpromotora: evento.idpromotora, 
            idevento: evento.idevento            
        });

        await this.props.pesquisaCategorias({
            idpromotora: evento.idpromotora, 
            idevento: evento.idevento
        })
    }

    handleSubmit = async (form) => {
        
        
        const evento = getEvento();

        form.categoria.map(async dados => {
            const cadupdate = {
                idpromotora: evento.idpromotora, 
                idevento: evento.idevento,
                ...form,
                categoria: dados
            }
            
            await this.props.novoatualiza(cadupdate);

            await this.props.pesquisa({
                idpromotora: evento.idpromotora, 
                idevento: evento.idevento,            
            });
        })
    }
        
    handleModalCadastro = (form) => {
        form.reset();
        this.setState({
            perguntaedicao: false
        });
    }
    
    handleCadastroPergunta = (pergunta) => {        
        if(pergunta === false){
            this.setState({
                perguntaedicao: pergunta
            });
            return false;
        } 
        
        let dados = {};
        if(Object.keys(pergunta).length){
            dados = {
                idpergunta: pergunta.idpergunta?pergunta.idpergunta:0,
                portugues: pergunta.portugues,
                ingles: pergunta.ingles,
                espanhol: pergunta.espanhol,
                passo: pergunta.passo,
                mostraperg: pergunta.mostraperg,
                categoria: [pergunta.categoria]
            } 
            
            if(pergunta&&parseInt(pergunta.passo)===6){
                dados = {
                    ...dados,
                    portugues_ue: pergunta.portugues_ue,
                    ingles_ue: pergunta.ingles_ue,
                    espanhol_ue: pergunta.espanhol_ue,
                    api_marketing: pergunta.api_marketing,
                    api_sms: pergunta.api_sms,
                    api_third: pergunta.api_third,
                    api_correio: pergunta.api_correio,
                    api_email: pergunta.api_email,
                    api_fone: pergunta.api_fone
                }
            }
        }
        
        this.setState({
            perguntaedicao: dados
        });
    }

    handleCadastroRespostaPergunta = (pergunta) => {        
        this.setState({
            perguntarespostasedicao: pergunta&&this.state.perguntarespostasedicao.idpergunta===pergunta.idpergunta?false:pergunta
        })
    }

    handleShowRespostas = (idpergunta) => {
        this.setState({
            showrespostas: this.state.showrespostas===idpergunta?false:idpergunta
        });
    }

    handlePosicaoPerg = (event, idpergunta, indice) => {
        console.log(event, idpergunta, indice);
    }
                
    render(){   
        const that = this;
        const dragProps = {
        async onDragEnd(fromIndex, toIndex) {

            const data = [...that.props.cadastros];
            const item = data.splice(fromIndex, 1)[0];
            data.splice(toIndex, 0, item);
            
            const evento = getEvento();

            await that.props.novoatualiza({
                idpromotora: evento.idpromotora, 
                idevento: evento.idevento,
                codigo: `${toIndex+1}`.padStart(3,'0'), 
                idpergunta: item.idpergunta
            });

            await that.props.novoatualiza({
                idpromotora: evento.idpromotora, 
                idevento: evento.idevento,
                codigo: `${fromIndex+1}`.padStart(3,'0'), 
                idpergunta: that.props.cadastros[toIndex].idpergunta
            });
        
            that.props.atualizaPesquisa(data);
            },
            nodeSelector: 'li',
            handleSelector: 'a'
        };     

        return (
            <>
            <TelaModalLivre 
                show={this.state.perguntarespostasedicao!==false?true:false} 
                handleCloseModal={() => this.handleCadastroRespostaPergunta(this.state.perguntarespostasedicao)}>                
                <FormPergRespCadastroRespostas 
                cadastros={this.state.perguntarespostasedicao}
                perguntas={this.props.cadastros}
                />                
            </TelaModalLivre>
            <FormFinal
            onSubmit={this.handleSubmit}
            initialValues={this.state.perguntaedicao}
            validate={(form) => {
                const errors = {};

                if(!form.categoria){
                    errors.categoria = 'Obrigatório';
                }

                if(!form.portugues){
                    errors.portugues = 'Obrigatório';
                }

                if(!form.passo){
                    errors.passo = 'Obrigatório';
                }

                return errors;
            }}
            render={({ submitting, pristine, form, handleSubmit, submitSucceeded }) => {
                this.formfinal = form;                
                const gravou = submitSucceeded&&this.props.cadupdated&&this.props.cadupdated.idpergunta?true:false;                
                return (
                    <form onSubmit={handleSubmit}>
                        <TelaModalLivre show={gravou} handleCloseModal={() => this.handleModalCadastro(form)}>
                            <Alert variant="success">Cadastro Feito com Sucesso</Alert>
                        </TelaModalLivre>
                            {this.props.categorias.length&&this.props.categorias.map((categoria, indice) => ( 
                            <Card key={indice} className="mb-4" style={{backgroundColor: (indice+1)%2?'#f6f7f8':'#fff'}}>
                                <Card.Title className="text-center">{categoria.baseformcategoria.descricao}</Card.Title>
                                <ReactDragListView {...dragProps}>
                                    <ol>                                    
                                        {this.props.cadastros.length?this.props.cadastros.map((itens, indice) => {
                                            
                                            if(categoria.categoria !== itens.categoria){
                                                return null;
                                            }
                                            
                                            return (
                                                <li key={indice} style={{listStyle: "none"}} className="ml-1 mr-1">
                                                    <Table striped bordered style={{marginBottom: '10px'}} variant={`${(indice+1) % 2?"secondary":""}`}>
                                                        <thead>
                                                            <tr>
                                                                <th colSpan="4" className="text-left">                                                                    
                                                                    <p>{itens.portugues}</p>
                                                                    <CommentEdit size="35" title="Editar Pergunta" style={{cursor: "pointer"}} onClick={() => this.handleCadastroPergunta(itens)} />
                                                                    {this.state.showrespostas!==false&&this.state.showrespostas===itens.idpergunta?
                                                                    <ChevronsUp size="35" style={{cursor: "pointer"}} title="Recolher" onClick={() => this.handleShowRespostas(itens.idpergunta)}/>
                                                                    :
                                                                    <ChevronsDown size="35" style={{cursor: "pointer"}} title="Mostrar Respostas" onClick={() => this.handleShowRespostas(itens.idpergunta)}/>
                                                                    }
                                                                    <a href="#" title="Reordenar"><Drag size="35" /></a>                                                                    
                                                                </th>
                                                            </tr>                                            
                                                        </thead>
                                                        <tbody style={{display: this.state.showrespostas!==false&&this.state.showrespostas===itens.idpergunta?"":"none"}}>
                                                            <tr>                                                
                                                                <td className="text-center">Inglês</td>
                                                                <td className="text-center">Espanhol</td>                                                
                                                            </tr>
                                                            <tr>                                                
                                                                <td className="text-break">
                                                                    {itens.ingles}
                                                                </td>
                                                                <td className="text-break">
                                                                    {itens.espanhol}
                                                                </td>                                                
                                                            </tr>
                                                            <tr>
                                                                <td className="text-right" colSpan="4">
                                                                    <Button onClick={() => this.handleCadastroRespostaPergunta(itens)}>
                                                                        Respostas <QuestionAnswer size="35" style={{cursor: "pointer"}} />
                                                                    </Button>
                                                                </td>
                                                            </tr>                                            
                                                        </tbody>
                                                    </Table>    
                                                </li>                                                                 
                                            )                                    
                                        })
                                        :null
                                        }
                                    </ol>
                                </ReactDragListView>
                            </Card>
                            ))}
                        {this.state.perguntaedicao!==false?
                        <Card style={{position: 'sticky', bottom: '50px', maxWidth: "100%"}} className='bg-info text-white'>
                            <Card.Body>
                                <Field type="hidden" name="idpergunta" component={campotexto} />
                                <Form.Row>
                                    <Form.Group as={Col} md="4" controlId="passo">
                                        <Field label="Opt-In" name="passo" component={camposelect}
                                        options={[{'value': 1, 'texto': 'NÃO'}, {'value': 2,'texto': 'Internacional'}, {'value': 6,'texto': 'Europeu'}]}
                                        />
                                    </Form.Group>
                                    <OnChange name="passo">
                                        {(value) => {
                                            this.setState({
                                                passo: value
                                            });
                                        }}
                                    </OnChange>                                    
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col} md="4" controlId="categoria">
                                        <Field type="select" label="Categoria" value={[]} multiple name="categoria" component={camposelect}
                                        options={this.props.categorias&&this.props.categorias.map(categoria => {
                                            return {value: categoria.categoria, texto: categoria.baseformcategoria.descricao};
                                        })}
                                        />
                                    </Form.Group>                                    
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col} md="4" controlId="portugues">
                                        <Field type="textarea" label="Português" name="portugues" placeholder="Português" component={campotexto}/>
                                    </Form.Group>
                                    <Form.Group as={Col} md="4" controlId="ingles">
                                        <Field type="textarea" label="Inglês" name="ingles" placeholder="Inglês" component={campotexto} />
                                    </Form.Group>
                                    <Form.Group as={Col} md="4" controlId="espanhol">
                                        <Field type="textarea" label="Espanhol" name="espanhol" placeholder="Espanhol" component={campotexto} />
                                    </Form.Group>
                                </Form.Row>   
                                {(this.state.perguntaedicao&&parseInt(this.state.perguntaedicao.passo)===6)||parseInt(this.state.passo)===6?
                                <>                                
                                <Form.Row>
                                    <Form.Group as={Col} md="4" controlId="api_marketing">
                                        <Card.Header>Api-Marketing</Card.Header>
                                        <Field type="radio" label="Sim" name="api_marketing" value="S" component={camporadio} />
                                        <Field type="radio" label="Não" name="api_marketing" value="N" component={camporadio} />
                                    </Form.Group>                             
                                    <Form.Group as={Col} md="4" controlId="api_sms">
                                        <Card.Header>APi-SMS</Card.Header>
                                        <Field type="radio" label="Sim" name="api_sms" value="S" component={camporadio} />
                                        <Field type="radio" label="Não" name="api_sms" value="N" component={camporadio} />
                                    </Form.Group>
                                    <Form.Group as={Col} md="4" controlId="api_third">
                                        <Card.Header>APi-Terceiro</Card.Header>
                                        <Field type="radio" label="Sim" name="api_third" value="S" component={camporadio} />
                                        <Field type="radio" label="Não" name="api_third" value="N" component={camporadio} />
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col} md="4" controlId="api_correio">
                                        <Card.Header>Api-Correio</Card.Header>
                                        <Field type="radio" label="Sim" name="api_correio" value="S" component={camporadio} />
                                        <Field type="radio" label="Não" name="api_correio" value="N" component={camporadio} />
                                    </Form.Group>                             
                                    <Form.Group as={Col} md="4" controlId="api_email">
                                        <Card.Header>Api-Email</Card.Header>
                                        <Field type="radio" label="Sim" name="api_email" value="S" component={camporadio} />
                                        <Field type="radio" label="Não" name="api_email" value="N" component={camporadio} />
                                    </Form.Group>
                                    <Form.Group as={Col} md="4" controlId="api_fone">
                                        <Card.Header>Api-Fone</Card.Header>
                                        <Field type="radio" label="Sim" name="api_fone" value="S" component={camporadio} />
                                        <Field type="radio" label="Não" name="api_fone" value="N" component={camporadio} />
                                    </Form.Group>
                                </Form.Row>   
                                </> 
                                :
                                null
                                }                        
                                <Button type="submit" disabled={pristine || submitting} className="mr-2">
                                    Confirmar
                                </Button>
                                <Button type="button" onClick={() => this.handleCadastroPergunta(false)}>
                                    Cancelar
                                </Button>
                            </Card.Body>
                        </Card>
                        :
                        <Table striped bordered hover className="table-dark" style={{position: 'sticky', bottom: '50px', maxWidth: "100%"}}>
                            <tbody>                                
                                <tr>
                                    <td className="text-center" colSpan="3">
                                        <Button type="button" onClick={() => this.handleCadastroPergunta({})}>
                                            Nova Pergunta
                                        </Button>
                                    </td>
                                </tr>                                          
                            </tbody>
                        </Table>
                        }
                    </form>
                )
            }}
            />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks,
        cadastros: state.pergrespReducer,
        cadupdated: state.pergCadAtualizaReducer,
        categorias: state.formsPesquisaCategoriasReducer
    }
}

export default connect(mapStateToProps, { pesquisa, novoatualiza, atualizaPesquisa, pesquisaCategorias })(FormPergRespCadastro);